import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { useTabContentContext } from 'Views/Page/Content/Templates/WhatIfTemplate/Content/RightSide/BottomPart/DetailPicker/Details/Context';
import MetaCollectionFormInline from 'Components/UI/Meta/MetaForm/MetaCollectionFormInline';
import Fade from '@mui/material/Fade';
import Typography from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Typography';
import SummaryCardPicker
  from 'Views/Page/Content/Templates/WhatIfTemplate/Content/RightSide/BottomPart/SummaryCardPicker';
import OutcomeGroups
  from 'Views/Page/Content/Templates/WhatIfTemplate/Content/RightSide/BottomPart/DetailPicker/Details/Content/TabTemplatePicker/Summary/OutcomeGroups';
import metaOverrides from './MetaOverrides';

const styles = theme => ({
  root: {
    padding: theme.spacing(0, 4, 2),
  },
  summaryCardMetaForm: {
    padding: 0,
  },
  noOutcomesPlaceholder: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
    padding: theme.spacing(8, 2),
  },
});

const Styleless = ({ className, ...props }) => <Box {...props} />;

const SummaryTabTemplate = ({ className, classes }) => {
  const { activeTabResource } = useTabContentContext();
  const hasOutcomes = Boolean(activeTabResource?.attr('outcomes')?.resources()?.list()?.length > 0);

  return (
    <Fade in timeout={500}>
      <Box className={classNames(classes.root, className)}>
        <OutcomeGroups />
        {activeTabResource && hasOutcomes ? (
          <MetaCollectionFormInline
            className={classes.summaryCardMetaForm}
            collection={activeTabResource?.attr('outcomes')}
            FormProps={{
              component: Styleless,
              layout: SummaryCardPicker,
              noIndividualSubmitButtons: true,
            }}
            metaOverrideSet={metaOverrides}
          />
        ) : (
          <Box className={classes.noOutcomesPlaceholder}>
            <Typography
              variant={'h4'}
              color={'primary'}
              weight={'bold'}
            >
              {'No Outcomes'}
            </Typography>
            <Typography
              variant={'h6'}
              color={'primary'}
              weight={'book'}
            >
              {'Once created, they will appear here.'}
            </Typography>
          </Box>
        )}
      </Box>
    </Fade>
  );
};

SummaryTabTemplate.defaultProps = {
  className: '',
};

SummaryTabTemplate.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(SummaryTabTemplate);
